// Overlapping supporter avatars, matching the social-proof cluster on the homepage previews.
const AVATARS = [
  '/avatars/avatar-1.jpg',
  '/avatars/avatar-2.jpg',
  '/avatars/avatar-3.jpg',
  '/avatars/avatar-4.jpg',
  '/avatars/avatar-5.jpg',
  '/avatars/avatar-6.jpg',
  '/avatars/avatar-7.jpg',
  '/avatars/avatar-8.jpg',
  '/avatars/avatar-9.jpg',
  '/avatars/avatar-10.jpg',
  '/avatars/avatar-11.jpg',
  '/avatars/avatar-12.jpg',
]

// Cause → badge tint, so the decorative grid reads as a spread of different causes.
const CAUSE_COLORS: Record<string, string> = {
  Health: 'bg-rose-100 text-rose-700',
  Housing: 'bg-orange-100 text-orange-700',
  'Arts & Culture': 'bg-violet-100 text-violet-700',
  Environment: 'bg-emerald-100 text-emerald-700',
  Education: 'bg-sky-100 text-sky-700',
  'Hunger & Poverty': 'bg-amber-100 text-amber-700',
}

const IMG = (id: string) =>
  `https://images.unsplash.com/${id}?w=400&q=80&auto=format&fit=crop`

const EVENTS = [
  { name: "Spring Gala for Children's Health", cause: 'Health', city: 'New York', month: 'May', day: '17', image: IMG('photo-1519671482749-fd09be7ccebf') },
  { name: 'Founders Dinner: A Decade of Shelter', cause: 'Housing', city: 'Seattle', month: 'May', day: '24', image: IMG('photo-1414235077428-338989a2e8c0') },
  { name: 'Renaissance Ball 2026', cause: 'Arts & Culture', city: 'Manhattan', month: 'Jun', day: '02', image: IMG('photo-1470229722913-7c0e2dbbafd3') },
  { name: 'Meadow & Sea Auction', cause: 'Environment', city: 'Boston', month: 'Jun', day: '14', image: IMG('photo-1505118380757-91f5f5632de0') },
  { name: 'Cinema Under the Stars', cause: 'Arts & Culture', city: 'Los Angeles', month: 'Jun', day: '21', image: IMG('photo-1489599849927-2ee91cede3ba') },
  { name: 'Harvest Table 2026', cause: 'Hunger & Poverty', city: 'Chicago', month: 'Jul', day: '09', image: IMG('photo-1466637574441-749b8f19452f') },
]

const FALLBACK_COLOR = 'bg-primary/10 text-primary'

const avatarClassName = (index: number) =>
  [
    'size-7 rounded-full object-cover ring-2 ring-card',
    index >= 8 ? 'hidden md:block' : index >= 5 ? 'hidden sm:block' : '',
  ].filter(Boolean).join(' ')

// Static decorative mock of the discover-events grid. Not interactive.
export default function EventListPreview({ title = 'Discover Events' }: { title?: string }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/10 bg-card shadow-xs">
      <div className="flex items-center justify-between gap-3 border-b border-black/5 p-4">
        <p className="min-w-0 flex-1 truncate text-sm font-semibold tracking-tight">{title}</p>
        <div className="flex shrink-0 items-center gap-2">
          <div className="flex -space-x-2">
            {AVATARS.map((src, i) => (
              <img
                key={i}
                src={src}
                alt=""
                width={28}
                height={28}
                className={avatarClassName(i)}
              />
            ))}
          </div>
          <span className="text-xs font-semibold text-primary">+9k supporting</span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-3">
        {EVENTS.map((e) => (
          <div key={e.name}>
            <div className="relative overflow-hidden rounded-lg">
              <img src={e.image} alt="" className="h-20 w-full object-cover" />
              <div className="absolute inset-x-0 bottom-0 h-10 bg-linear-to-t from-black/40 to-transparent" />
              <span className={`absolute bottom-1.5 left-1.5 rounded px-1.5 py-0.5 text-[10px] font-medium ${CAUSE_COLORS[e.cause] ?? FALLBACK_COLOR}`}>
                {e.cause}
              </span>
            </div>
            <p className="mt-2 line-clamp-2 text-xs font-medium leading-snug text-foreground">{e.name}</p>
            <p className="mt-1 truncate text-[11px] text-muted-foreground">{e.month} {e.day} · {e.city}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
